import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import { PanelCheckList } from 'components/panelCheckList';
import I18n from 'components/translate/I18n';
import { ContentService } from 'modules/content';
import { MODULE_NAME_MAX_CHARACTERS } from 'modules/content/constants';
import PropTypes from 'prop-types';

import { TYPES } from '../sortable/constants';

import './ModuleSelectionStep.scss';

const formatItem = (item) => {
  return (
    <div className="module-selection__page-list-panel__item">
      <span className="module-selection__page-list-panel__name">
        {item.name}
      </span>
      <p className="module-selection__page-list-panel__type">
        <I18n label={`general.${TYPES[item.type].label}`} />
        <span>{TYPES[item.type].icon}</span>
      </p>
    </div>
  );
};

const ModuleSelectionStep = ({
  moduleId,
  moduleName,
  onChange,
  onModuleNameChange
}) => {
  const [isLoadingPages, setIsLoadingPages] = useState(true);
  const [pageList, setPageList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);

  const isModuleNameTooLong = moduleName.length > MODULE_NAME_MAX_CHARACTERS;

  const onChangeCheckedList = (pages) => {
    setCheckedList(pages);
    onChange(pages);
  };

  useEffect(() => {
    const getDuplicationPages = async () => {
      const response = await ContentService.getDuplicationPages(moduleId);
      const checkedPages = (response || []).map((item) => item.id);

      setPageList(response);
      setIsLoadingPages(false);
      onChangeCheckedList(checkedPages);
    };

    getDuplicationPages();
  }, [moduleId]);

  const onNameChange = (e) => {
    onModuleNameChange(e.target.value);
  };

  const formatItems = (pageList) => {
    return (pageList || []).map((page) => ({
      ...page,
      value: page.id,
      labelValue: page.name,
      checked: (checkedList || []).includes(page.id)
    }));
  };

  const formatSubheader = (item) => (
    <span className="module-selection__page-list-panel__subheader">
      <span>{item.name}</span>
      <span className="module-selection__page-list-panel__subheader__info">
        <I18n
          label="content_list.content_duplication.n_pages"
          data={{ pages: pageList.length, count: pageList.length }}
        />
      </span>
    </span>
  );

  const counterClasses = classNames('module-selection__name__title', {
    '_text-red': isModuleNameTooLong
  });

  const inputClasses = classNames('hot-form__input hot-form__input--md', {
    '_border-red': isModuleNameTooLong
  });

  return (
    <div className="module-selection">
      <div className="_d-flex _justify-content-between _align-items-center module-selection__name">
        <h6 className="module-selection__name__title">
          <I18n label="content_list.content_duplication.module_name" />
        </h6>
        <span className={counterClasses}>
          {moduleName.length}
          {'/'}
          {MODULE_NAME_MAX_CHARACTERS}
        </span>
      </div>
      <input
        type="text"
        className={inputClasses}
        value={moduleName}
        name="module-name"
        onChange={onNameChange}
      />
      <div className="module-selection__page-list">
        <h5 className="module-selection__page-list__modules_question">
          <I18n label="content_list.content_duplication.module_list" />
        </h5>
      </div>
      <PanelCheckList
        name="duplicationCandidates"
        className="module-selection__page-list-panel"
        loading={isLoadingPages}
        value={pageList}
        formatItems={formatItems}
        formatItem={formatItem}
        formatSubheader={formatSubheader}
        onChange={(event) => onChangeCheckedList(event.target.value)}
      />
    </div>
  );
};

ModuleSelectionStep.propTypes = {
  moduleId: PropTypes.string.isRequired,
  moduleName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onModuleNameChange: PropTypes.func.isRequired
};

export default ModuleSelectionStep;
